import WebStorage from '@/common/WebStorage';

type TelemetryEvent = 'login' | 'functionality_accessed' | 'integration_health_check' | 'resource_managed';

interface EventPayload {
  [key: string]: any;
}

class AnalyticsService {

  track(event: TelemetryEvent, payload: EventPayload) {
    if ((window as any).dataLayer) {
      (window as any).dataLayer.push({
        event,
        ...payload,
      });
    }
  }

  login() {
    const userProfile = WebStorage.getItem('userProfile');
    const accountData = JSON.parse(WebStorage.getItem('accountInfo'));
    const userData = WebStorage.getItem('userInfo');

    this.track('login', {
      user: userData.email,
      user_id: userData.id,
      user_name: userData.person,
      tenant_name: accountData.name,
      tenant_id: accountData.tenantId,
      user_profile: userProfile.description,
    });
  }

  functionalityAccessed(functionality: string) {
    const userProfile = WebStorage.getItem('userProfile');
    const accountData = JSON.parse(WebStorage.getItem('accountInfo'));
    const userData = WebStorage.getItem('userInfo');

    this.track('functionality_accessed', {
      user: userData.email,
      user_id: userData.id,
      user_name: userData.person,
      tenant_name: accountData.name,
      tenant_id: accountData.tenantId,
      user_profile: userProfile.description,
      functionality,
    });
  }

  integrationHealthCheck(action: string) {
    const userProfile = WebStorage.getItem('userProfile');
    const accountData = JSON.parse(WebStorage.getItem('accountInfo'));
    const userData = WebStorage.getItem('userInfo');

    this.track('integration_health_check', {
      user: userData.email,
      user_id: userData.id,
      user_name: userData.person,
      tenant_id: accountData.tenantId,
      tenant_name: accountData.name,
      user_profile: userProfile.description,
      action,
    });
  }

  resourceManaged(resource: string, action: string) {
    const userProfile = WebStorage.getItem('userProfile');
    const accountData = JSON.parse(WebStorage.getItem('accountInfo'));
    const userData = WebStorage.getItem('userInfo');

    this.track('resource_managed', {
      user: userData.email,
      user_id: userData.id,
      user_name: userData.person,
      tenant_id: accountData.tenantId,
      tenant_name: accountData.name,
      user_profile: userProfile.description,
      resource,
      action,
    });
  }
}

export default AnalyticsService;